import { Row } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import KAddressInput from 'app/components/Modules/Form/KAddressInput'
import KForm from 'app/components/Modules/Form/KForm'
import KFormInfo from 'app/components/Modules/Form/KFormInfo'
import KInputText from 'app/components/Modules/Form/KInputText'
import KNestedFields from 'app/components/Modules/Form/KNestedFields'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { KLARX_INFO_EMAIL, KLARX_PHONE, KLARX_PHONE_DISPLAY } from 'app/constants/Global'
import { KFormProps, RecordType } from 'app/constants/GlobalTypes'
import { useRestriction } from 'app/lib/hooks/useRestriction'
import { attributeNames } from 'app/lib/utils/customer-address'

const OrganizationForm: React.FC<MemberProps<ICustomer, KFormProps<ICustomer>>> = ({
  member,
  props = {}
}) => {
  const { restricted } = useRestriction({ allowFor: ['admin'] })

  const payloadModifier = (values: ICustomer) => ({
    ...values,
    legal_address: {
      ...values.legal_address,
      address: values.legal_address.address1 || values.legal_address.address
    }
  })

  return (
    <KForm
      recordId={member?.id}
      recordType={RecordType.customer}
      layout="vertical"
      hideSubmit={restricted}
      forceAction="update"
      payloadModifier={payloadModifier}
      {...props}>
      <fieldset disabled={restricted}>
        <Row gutter={[24, 0]}>
          <KCol xs={24} md={12}>
            <KInputText required={false} name="organization" disabled />
          </KCol>
          <KCol xs={24} md={12}>
            <KInputText required={false} name="company_registration_number" />
          </KCol>
          <KCol xs={24} md={12}>
            <KInputText required={false} name="homepage" />
          </KCol>
          <KCol xs={24} md={12}>
            <KInputText required={false} name="legal_form" disabled />
          </KCol>
          <KCol xs={24} md={12}>
            <KInputText required={false} name="email" />
          </KCol>
          <KCol xs={24} md={12}>
            <KInputText required={false} name="tel" />
          </KCol>
          <KCol xs={24} md={12}>
            <KNestedFields as={RecordType.legal_address}>
              <KAddressInput
                required={false}
                name="address_summary"
                defaultExpand
                disabled={member?.solvent}
                names={attributeNames}
              />
              <If condition={member?.solvent}>
                <KFormInfo
                  values={{
                    email: <a href={`mailto:${KLARX_INFO_EMAIL}`}>{KLARX_INFO_EMAIL}</a>,
                    tel: <a href={`tel:${KLARX_PHONE}`}>{KLARX_PHONE_DISPLAY}</a>
                  }}
                />
              </If>
            </KNestedFields>
          </KCol>
        </Row>
      </fieldset>
    </KForm>
  )
}

export default OrganizationForm
